import React from "react";
import ReactDOM from "react-dom";
import App from "./Components/App";
import { BrowserRouter as Router } from "react-router-dom";
import Amplify from "aws-amplify";
import config from "./Libs/config";
import "./index.css";

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
    oauth: {
      domain: config.cognito.DOMAIN,
      scope: config.cognito.SCOPE,
      redirectSignIn: config.cognito.REDIRECT_SIGN_IN,
      redirectSignOut: config.cognito.REDIRECT_SIGN_OUT,
      responseType: config.cognito.RESPONSE_TYPE,
    },
  },
  API: {
    endpoints: [
      {
        name: config.apiGateway.MyVideo.NAME,
        region: config.apiGateway.MyVideo.REGION,
        endpoint: config.apiGateway.MyVideo.URL,
      },
      {
        name: config.apiGateway.Recognition.NAME,
        region: config.apiGateway.Recognition.REGION,
        endpoint: config.apiGateway.Recognition.URL,
      },
      {
        name: config.apiGateway.WebForm.NAME,
        region: config.apiGateway.WebForm.REGION,
        endpoint: config.apiGateway.WebForm.URL,
      },
      {
        name: config.apiGateway.QualityMonitoring.NAME,
        region: config.apiGateway.QualityMonitoring.REGION,
        endpoint: config.apiGateway.QualityMonitoring.URL,
      },
    ],
  },
  Interactions: {
    bots: {
      [config.Interactions.bots.MyRecognition.NAME]: {
        name: config.Interactions.bots.MyRecognition.NAME,
        region: config.Interactions.bots.MyRecognition.REGION,
        alias: config.Interactions.bots.MyRecognition.ALIAS,
      },
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
